const scrollToTarget = (parentRef, targetRef) => {
	if (!parentRef?.current || !targetRef?.current) {
		return;
	}
	let targetScroll = targetRef.current.getBoundingClientRect();
	let currScroll = parentRef.current.scrollTop;
	const handleScrollIntoView = () => {
		if (
			parentRef.current.scrollTop < currScroll ||
			parentRef.current.scrollTop >= targetScroll
		) {
			return;
		}
		currScroll = parentRef.current.scrollTop;
		parentRef.current.scrollTop = parentRef.current.scrollTop + 10;
		window.requestAnimationFrame(handleScrollIntoView);
	};
	window.requestAnimationFrame(handleScrollIntoView);
};

export default scrollToTarget;
